module.exports = __webpack_public_path__ + "src/app/_content/BMWFonts/BMWTypeNextPro-Thin.woff2?c7f6705ea991d250a359f78669921fc3";